import { useFilterByTAccId } from '../../utils';
import { usePersonAccountFieldApi } from '../api';

export const usePersonAccountsTAccTwrrYRdt = () => {
  const filterPredicate = useFilterByTAccId();
  const result = usePersonAccountFieldApi({
    filterPredicate,
    field: 'T_ACC_TWRR_Y.RDT',
  });
  return result;
};
